export function Logo({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg width="34" height="34" viewBox="0 0 64 64" aria-hidden>
        <rect x="6" y="6" width="52" height="52" rx="8" fill="#fdf6ee" stroke="#2a1a14" strokeWidth="2" />
        <rect x="10" y="10" width="44" height="34" fill="#f5b942" />
        <circle cx="32" cy="27" r="9" fill="#f87060" />
        <rect x="10" y="48" width="44" height="6" fill="#fdf6ee" />
      </svg>
      <span className="font-display font-black text-xl tracking-tight text-coral">
        the<span className="text-ink">live</span>photos
      </span>
    </span>
  );
}
